// extracted by mini-css-extract-plugin
module.exports = {"checkboxWrapper":"MultiLineCheckbox_checkboxWrapper__pN8wc","checkbox":"MultiLineCheckbox_checkbox__DAJQh","checkedBox":"MultiLineCheckbox_checkedBox__SzZ9F"};